import {ReactElement} from 'react';
import {Link} from '@shopify/hydrogen';
import {WhiskyBarType} from '../../types';
interface BarInfoProps {
  whiskyBar: WhiskyBarType;
}

export default function BarInfo({whiskyBar}: BarInfoProps): ReactElement {
  let websiteDomain;
  try {
    websiteDomain = new URL(whiskyBar.website_url).hostname;
  } catch (error) {
    if (!(error instanceof TypeError)) {
      throw error;
    }
  }

  return (
    <section>
      <div className="page-title container">
        {whiskyBar.is_partner && (
          <div className="limited-label">
            <i className="icon-twl-partner"></i> <span>TWL PARTNER</span>
          </div>
        )}
        <h1 className="title-0 page-title__heading">{whiskyBar.name}</h1>
        <h6 className="page-subtitle">{whiskyBar.tagline}</h6>
        <div className="page-title__meta mt-20">
          <div className="page-title__meta-element">
            <i className="icon-pin"></i>

            {whiskyBar.map_address_url ? (
              <Link to={whiskyBar.map_address_url} target="_blank">
                {whiskyBar.address}
              </Link>
            ) : (
              <span>{whiskyBar.address}</span>
            )}
          </div>
          {websiteDomain && (
            <div className="page-title__meta-element">
              <i className="icon-the-whisky-show-website"></i>
              <Link to={whiskyBar.website_url} target="_blank">
                {websiteDomain}
              </Link>
            </div>
          )}
          <div className="page-title__meta-element">
            <i className="icon-tag"></i>
            <span>{whiskyBar.specialities.join(', ')}</span>
          </div>
          <div className="page-title__meta-element">
            <i className="icon-bottle"></i>
            <span>{whiskyBar.number_of_whiskies} Whisky bottles</span>
          </div>
        </div>
      </div>
    </section>
  );
}
